import { useLayoutEffect } from 'react';

const DEFAULT_TITLE = 'Fullglass AI';

export const usePageTitle = (titleSuffix: string) => {
  useLayoutEffect(() => {
    document.title =
      titleSuffix.trim() === '' ? DEFAULT_TITLE : `${DEFAULT_TITLE} | ${titleSuffix}`;

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [titleSuffix]);
};
